import { EPartnerCategory } from '@/constants/sponsor';

/**
 * A sub-fleet is a fleet partner whose main sponsor is a carsharing partner
 * operating under a corporation partner. Such partners get a restricted portal
 * view (e.g. Driver Management is hidden).
 */
export function isSubFleetPartner(
  partnerSettings: Record<string, any> | null | undefined,
): boolean {
  const businessContext = partnerSettings?.mainSponsor?.businessContext;
  return (
    businessContext?.partnerCategory === EPartnerCategory.CARSHARING &&
    !!businessContext?.corporationPartner
  );
}

/**
 * A car-sharing fleet is any partner whose main sponsor sits in the CARSHARING category —
 * broader than `isSubFleetPartner`, which additionally requires a corporation partner.
 */
export function isCarSharingFleetPartner(
  partnerSettings: Record<string, any> | null | undefined,
): boolean {
  return (
    partnerSettings?.mainSponsor?.businessContext?.partnerCategory === EPartnerCategory.CARSHARING
  );
}
